import { render, staticRenderFns } from "./UpdateOrderGiftCardContent.vue?vue&type=template&id=6bb8145c"
import script from "./UpdateOrderGiftCardContent.vue?vue&type=script&lang=js"
export * from "./UpdateOrderGiftCardContent.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrderGiftCardContent.vue?vue&type=style&index=0&id=6bb8145c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports